module.exports = __webpack_public_path__ + "img/phone_purple.95797495.svg";